// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotificationUserThankYou_wrapper__384AI","header":"NotificationUserThankYou_header__3zoIg","container":"NotificationUserThankYou_container__jNglN"};